<template>
  <div class="appointment-next" v-if="id">
    <div class="appointment-calendar md-whiteframe-16dp" :class="{ 'appt-lg': !isCompact }">
      <span class="header">{{ getShortMonth }}</span>
      <span class="date">{{ getCurrentDay }}</span>
    </div>
    <div class="appointment-details" :class="{ 'appt-lg': !isCompact }">
      <div class="appointment-date">{{ getFullDate }}</div>
      <div class="appointment-location">DANCKUTS / {{ location.name }}</div>
      <div class="appointment-address">{{ location.address }}</div>
      <div class="appointment-city">{{ location.city }}, {{ location.state }} {{ location.zip }}</div>
      <div>
        <a class="appointment-button" @click="addAppt" v-show="!exists">Add This Appt</a>
      </div>
      <div>
        <a class="appointment-button" @click="cancelAppt" v-show="exists">CANCEL</a>
      </div>
      <div>
        <a class="appointment-button" @click="rescheduleAppt" v-show="exists">RESCHEDULE</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'appointment',
  props: {
    id: null,
    date: null,
    location: {
      name: null,
      address: null,
      city: null,
      state: null,
      zip: null
    },
    isCompact: null,
    exists: null
  },
  data: function () {
    return {
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      shortMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],
      days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ]
    }
  },
  computed: {
    getDate: function () {
      return new Date(this.date)
    },
    getFullDate: function () {
      var d = this.getDate
      return (
        this.days[d.getDay()] +
        ', ' +
        this.months[d.getMonth()] +
        ' ' +
        d.getDate() +
        ', ' +
        d.getFullYear() +
        ' ' +
        this.addZero(d.getHours()) +
        ':' +
        this.addZero(d.getMinutes())
      )
    },
    getShortMonth: function () {
      var d = this.getDate
      return this.shortMonths[d.getMonth()]
    },
    getCurrentDay: function () {
      var d = this.getDate
      return d.getDate()
    }
  },
  methods: {
    addZero: function (val) {
      return (val < 10 ? '0' : '') + val
    },
    cancelAppt: function () {
      // console.log('Cancel clicked')
    },
    rescheduleAppt: function () {
      // console.log('Reschkedule clicked')
    },
    addAppt: function () {
      // console.log('Add clicked')
    }
  }}
</script>

<style scoped lang="scss">
.appointment-calendar {
  display: inline-block;
  width: 150px;

  .header,
  .date {
    display: inline-block;
    text-align: center;
    width: 100%;
  }

  .header {
    background: #41bcee;
    color: #fff;
    letter-spacing: 2px;
    padding: 12px 0;
  }

  .date {
    font-size: 5.5em;
    font-weight: 100;
  }

  &.appt-lg {
    width: 400px;

    .header {
      font-size: 5em;
    }

    .date {
      font-size: 10em;
    }
  }
}

.appointment-details {
  display: inline-block;
  padding-left: 15px;
  vertical-align: top;

  .appointment-location {
    letter-spacing: 4px;
    padding-bottom: 6px;
    padding-top: 8px;
    text-transform: uppercase;
  }

  .appointment-button {
    color: #41bcee;
    font-size: 0.7em;
    letter-spacing: 4px;
    margin: 0;
    min-height: inherit;
    min-width: inherit;
    padding: 0;
  }

  &.appt-lg {
    .appointment-date, .appointment-location, .appointment-address, .appointment-city, .appointment-button {
      font-size: 200%;
      font-weight: 300;
    }
  }
}
</style>
